module.exports = __webpack_public_path__ + "img/extra_menu.d3a9edff.png";